import {Level} from '../../../shared/Level';
import {Mode} from '../../../shared/Mode';
import {CdsActivity} from '../../../shared/CdsActivity';

export class CanDoStatementEntryCreationDto {
  constructor(
    public id: number,
    public name: string,
    public categoryId: number,
    public receptive: Level,
    public productive: Level,
    public mode: Mode,
    public activity: CdsActivity,
    public vocabCategoryIds: number[],
    public vocabEntryIds: number[],
    public functionalGrammarCategoryIds: number[],
    public functionalGrammarEntryIds: number[],
    public systemicGrammarCategoryIds: number[],
    public systemicGrammarEntryIds: number[],
    public textPatternIds: number[],
    public textTypeIds: number[],
    public detailedCanDoStatementCategoryIds: number[],
    public detailedCanDoStatementEntryIds: number[],
    public globalCanDoStatementCategoryIds: number[],
    public globalCanDoStatementEntryIds: number[],
    public verbalActionCategoryIds: number[],
    public verbalActionEntryIds: number[]
  ) {
  }
}
